
  <div class="preload preload-container">
      <div class="preload-logo">
          <div class="spinner"></div>
      </div>
  </div>
  <!-- /preload -->
  <div id="wrapper">

      <!-- page-title -->
      <div class="tf-page-title">
          <div class="container-full">
              <div class="heading text-center">Finaliser la commande</div>
          </div>
      </div>
      <!-- /page-title -->

      <!-- page-cart -->
      <section class="flat-spacing-11">
          <div class="container">
              <div class="tf-page-cart-wrap layout-2">
                  <div class="tf-page-cart-item">
                      <h5 class="fw-5 mb_20">Détails de facturation</h5>
                      <form class="form-checkout">
                          <div class="box grid-2">
                              <fieldset class="fieldset">
                                  <label for="first-name">Prénom</label>

                                  <input type="text" class="form-control" id="first-name" name="prenom"
                                  [(ngModel)]="user.prenom" placeholder="Prénom" (input)="updateError('prenom')"/>
                                <p *ngIf="errors['prenom']" class="error-message" style="color: red;">
                                  {{ errors['prenom'] }}
                                </p>
                              </fieldset>
                              <fieldset class="fieldset">
                                  <label for="last-name">Nom</label>
                                  <input type="text" class="form-control"  id="last-name" name="name"
                [(ngModel)]="user.nom" placeholder="Nom de famille" (input)="updateError('nom')"/>
              <p *ngIf="errors['nom']" class="error-message" style="color: red;">
                {{ errors['nom'] }}
              </p>
                              </fieldset>
                          </div>

                          <fieldset class="box fieldset">
                              <label for="city">Ville</label>
                              <input type="text" class="form-control" id="city" name="city"
              [(ngModel)]="user.city" placeholder="Ville" (input)="onCityChange($event); updateError('city')"/>
             <p *ngIf="errors['city']" class="error-message" style="color: red;">
               {{ errors['city'] }}
             </p>
                          </fieldset>
                          <fieldset class="box fieldset">
                              <label for="address">Adresse</label>
                              <input type="text" class="form-control" id="address" name="address"
 [(ngModel)]="user.address" placeholder="Adresse" (input)="onAddressChange($event); updateError('address')"/>
<p *ngIf="errors['address']" class="error-message" style="color: red;">
  {{ errors['address'] }}
</p>
                          </fieldset>
                          <fieldset class="box fieldset">
                              <label for="phone">Telephone</label>
                              <input type="text" class="form-control" id="phone" name="number"
                [(ngModel)]="user.telephone" placeholder="Numéro de téléphone" (input)="updateError('telephone')"/>
              <p *ngIf="errors['telephone']" class="error-message" style="color: red;">
                {{ errors['telephone'] }}
              </p>
                          </fieldset>
                          <fieldset class="box fieldset">
                              <label for="email">Email</label>
                              <input type="text" class="form-control" id="email" name="compemailany"
                [(ngModel)]="user.email" placeholder="Adresse e-mail" (input)="updateError('email')"/>
              <p *ngIf="errors['email']" class="error-message" style="color: red;">
                {{ errors['email'] }}
              </p>
                          </fieldset>
                          <fieldset class="box fieldset">
                              <label for="note">Notes de commande</label>
                              <textarea name="note" id="note"  [(ngModel)]="user.orderNotes"></textarea>
                          </fieldset>
                      </form>
                  </div>
                  <div class="tf-page-cart-footer">
                      <div class="tf-cart-footer-inner">
                          <h5 class="fw-5 mb_20">Votre commande</h5>
                          <form class="tf-page-cart-checkout widget-wrap-checkout">
                            <ul class="wrap-checkout-product">
                              <li class="checkout-product-item" *ngFor="let item of cartItems">
                                <figure class="img-product">
                                  <img [src]="item.images[0]?.data" alt="product">
                                  <span class="quantity">{{ item.quantity }}</span>
                                </figure>
                                <div class="content">
                                  <div class="info">
                                    <p class="name">{{ item.libelle }}</p>
                                    <span class="variant">{{ item.couleur || 'N/A' }} / {{ item.taille || 'N/A' }}</span>
                                  </div>
                                  <span class="price">{{ (item.promo !== 0 ? item.prix_final : item.prix_ttc) * item.quantity | number:'1.2-2' }} DT</span>
                                </div>
                              </li>
                            </ul>

                              <div class="coupon-box">
                                  <input [(ngModel)]="couponCode" name="coupon" type="text" placeholder="Entrez le code promo">
                                  <a (click)="fetchCouponValue()"
                                      class="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn">Appliquer</a>

                              </div>
                              <div *ngIf="errorMessage" class="error-message">
                                <p>{{ errorMessage }}</p>
                              </div>

                              <!-- Message de succès -->
                              <div *ngIf="couponValue" class="success-message">
                                <p>Code promo appliqué : {{ couponValue }}% de réduction</p>
                              </div>
                              <div class="d-flex justify-content-between line pb_20">
                                <h6 class="fw-5">Livraison</h6>
                                <h6 class="total fw-5">8.000 DT</h6>
                              </div>
                              <div class="d-flex justify-content-between line pb_20">
                                <h6 class="fw-5">Total</h6>
                                <h6 class="total fw-5">{{ getTotalWithShipping() | number:'1.3-3' }}  DT</h6>
                              </div>

                              <div class="wd-check-payment">
                                  <div class="fieldset-radio mb_20">
                                      <input type="radio" name="payment" id="bank" class="tf-check" >
                                      <label for="bank">Paiement par chèque</label>

                                  </div>
                                  <div class="fieldset-radio mb_20">
                                      <input type="radio" name="payment" id="delivery" class="tf-check" checked>
                                      <label for="delivery">Paiement en espèces</label>
                                  </div>

                              </div>

                              <div id="modalOverlay" class="modal-overlay" *ngIf="isModalOpen"></div>
                              <div id="confirmationModal" class="modal" >
                                <div class="custom-modal-content">
                                  <span class="custom-close" (click)="closeModal('confirmationModal')">&times;</span>
                                  <h2 style="color:#aa0058; font-size:27px;  font-weight: bold" >Résumé de la commande</h2>


                                    <table class="order-table">
                                      <thead>
                                        <tr>
                                          <th>Description</th>
                                          <th>Prix</th>
                                          <th>Qté</th>
                                          <th>Montant</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let item of commandeObject.ligneCommande">
                                          <td>{{ item.libelle }}</td>

                                          <td>{{ item.prix_ttc_article | number:'1.3-3'    }}</td>
                                          <td>{{ item.nbr_article }}</td>
                                          <td>{{ item.nbr_article * item.prix_ttc_article |  number:'1.3-3' }}</td>
                                        </tr>
                                        <tr *ngFor="let pack of commandeObject.ligneCommandePack">
                                          <td>{{ pack.libelle}}</td>
                                          <td>{{ pack.prix_ttc_pack | number:'1.3-3' }}</td>
                                          <td>{{ pack.nbr_pack }}</td>
                                          <td>{{ pack.nbr_pack * pack?.prix_ttc_pack | number:'1.3-3' }}</td>
                                      </tr>

                                      </tbody>
                                    </table>



                                  <!-- Order Summary -->
                                  <div class="order-summary">
                                    <p><strong>Sous-total :</strong> {{ total |  number:'1.3-3' }} DT</p>
                                    <p>
                                      <strong>Livraison :</strong>

                                     8.000 DT
                                    </p>

                                    <p><strong>Total :</strong> {{ getTotalWithShipping() |  number:'1.3-3' }} DT</p>
                                  </div>

                                  <!-- Question de confirmation -->
                                  <p>Voulez-vous confirmer cette commande ?</p>
                                  <div class="modal-actions">
                                    <button class="btn-confirm" (click)="confirmOrder()">Confirmer</button>
                                    <button class="btn-cancel" (click)="closeModal('confirmationModal')">Annuler</button>
                                  </div>
                                </div>
                              </div>


                              <!-- Success modal -->
                              <div id="successModal" class="modal">
                                <div class="custom-modal-content">

                                  <p>  <i class="fas fa-check-circle" style="color: #4CAF50; margin-right: 10px;"></i>
                                    Commande passée avec succès !</p>
                                    <a *ngIf="isLoggedIn()" [routerLink]="'/accountinfos'" style="color: #4CAF50; text-decoration: underline; font-weight: bold; font-size: 18px;">
                                      Aller à l'historique des commandes
                                    </a>

                                </div>
                              </div>
                              <button
                                  class="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center" (click)="placeOrder()">Place
                                  order</button>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <!-- page-cart -->


  </div>

  <!-- gotop -->
  <button id="goTop">
      <span class="border-progress"></span>
      <span class="icon icon-arrow-up"></span>
  </button>
  <!-- /gotop -->

  <!-- toolbar-bottom -->
  <div class="tf-toolbar-bottom type-1150">
      <div class="toolbar-item">
          <a href="#toolbarShopmb" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-shop"></i>
              </div>
              <div class="toolbar-label">Shop</div>
          </a>
      </div>

      <div class="toolbar-item">
          <a href="#canvasSearch" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-search"></i>
              </div>
              <div class="toolbar-label">Recherche</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a  (click)="goToAccount($event)" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-account"></i>
              </div>
              <div class="toolbar-label">Compte</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="/wishlist">
              <div class="toolbar-icon">
                  <i class="icon-heart"></i>
                  <div class="toolbar-count">{{ wishlistCount }}</div>
              </div>
              <div class="toolbar-label">Favoris</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="#shoppingCart" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-bag"></i>
                  <div class="toolbar-count">{{ cartCount }}</div>
              </div>
              <div class="toolbar-label">Panier</div>
          </a>
      </div>
  </div>
  <!-- /toolbar-bottom -->

  <!-- modalDemo -->
  <div class="modal fade modalDemo" id="modalDemo">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <h5 class="demo-title">Ultimate HTML Theme</h5>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="mega-menu">
                  <div class="row-demo">
                      <div class="demo-item">
                          <a href="index.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-01.jpg"
                                      src="assets/images/demo/home-01.jpg" alt="home-01">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                      <span>Trend</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Fashion 01</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-multi-brand.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-multi-brand.jpg"
                                      src="assets/images/demo/home-multi-brand.jpg" alt="home-multi-brand">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                      <span class="demo-hot">Hot</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Multi Brand</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-02.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-02.jpg"
                                      src="assets/images/demo/home-02.jpg" alt="home-02">
                                  <div class="demo-label">
                                      <span class="demo-hot">Hot</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Fashion 02</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-03.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-03.jpg"
                                      src="assets/images/demo/home-03.jpg" alt="home-03">
                              </div>
                              <span class="demo-name">Home Fashion 03</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-04.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-04.jpg"
                                      src="assets/images/demo/home-04.jpg" alt="home-04">
                              </div>
                              <span class="demo-name">Home Fashion 04</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-05.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-05.jpg"
                                      src="assets/images/demo/home-05.jpg" alt="home-05">
                              </div>
                              <span class="demo-name">Home Fashion 05</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-06.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-06.jpg"
                                      src="assets/images/demo/home-06.jpg" alt="home-06">
                              </div>
                              <span class="demo-name">Home Fashion 06</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-drinkwear.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-drinkwear.png"
                                      src="assets/images/demo/home-drinkwear.png" alt="home-drinkwear">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Drinkwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-supplement.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-supplement.png"
                                      src="assets/images/demo/home-supplement.png" alt="home-supplement">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Supplement</span>
                          </a>
                      </div>

                      <div class="demo-item">
                          <a href="home-personalized-pod.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-personalized-pod.jpg"
                                      src="assets/images/demo/home-personalized-pod.jpg" alt="home-personalized-pod">
                              </div>
                              <span class="demo-name">Home Personalized Pod</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-pickleball.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-pickleball.png"
                                      src="assets/images/demo/home-pickleball.png" alt="home-pickleball">
                              </div>
                              <span class="demo-name">Home Pickleball</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-ceramic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-ceramic.png"
                                      src="assets/images/demo/home-ceramic.png" alt="home-ceramic">
                              </div>
                              <span class="demo-name">Home Ceramic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-food.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-food.png"
                                      src="assets/images/demo/home-food.png" alt="home-food">
                              </div>
                              <span class="demo-name">Home Food</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-camp-and-hike.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-camp-and-hike.png"
                                      src="assets/images/demo/home-camp-and-hike.png" alt="home-camp-and-hike">
                              </div>
                              <span class="demo-name">Home Camp And Hike</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-07.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-07.jpg"
                                      src="assets/images/demo/home-07.jpg" alt="home-07">
                              </div>
                              <span class="demo-name">Home Fashion 07</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-08.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-08.jpg"
                                      src="assets/images/demo/home-08.jpg" alt="home-08">
                              </div>
                              <span class="demo-name">Home Fashion 08</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-skincare.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                      src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                              </div>
                              <span class="demo-name">Home Skincare</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-headphone.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-headphone.jpg"
                                      src="assets/images/demo/home-headphone.jpg" alt="home-headphone">
                              </div>
                              <span class="demo-name">Home Headphone</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-giftcard.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-giftcard.jpg"
                                      src="assets/images/demo/home-giftcard.jpg" alt="home-gift-card">
                              </div>
                              <span class="demo-name">Home Gift Card</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-furniture.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-furniture.jpg"
                                      src="assets/images/demo/home-furniture.jpg" alt="home-furniture">
                              </div>
                              <span class="demo-name">Home Furniture</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-furniture-02.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-furniture2.jpg"
                                      src="assets/images/demo/home-furniture2.jpg" alt="home-furniture-2">
                              </div>
                              <span class="demo-name">Home Furniture 2</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-skateboard.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skateboard.jpg"
                                      src="assets/images/demo/home-skateboard.jpg" alt="home-skateboard">
                              </div>
                              <span class="demo-name">Home Skateboard</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-stroller.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-stroller.jpg"
                                      src="assets/images/demo/home-stroller.jpg" alt="home-stroller">
                              </div>
                              <span class="demo-name">Home Stroller</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-decor.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-decor.jpg"
                                      src="assets/images/demo/home-decor.jpg" alt="home-decor">
                              </div>
                              <span class="demo-name">Home Decor</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-electronic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-electronic.jpg"
                                      src="assets/images/demo/home-electronic.jpg" alt="home-electronic">
                              </div>
                              <span class="demo-name">Home Electronic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-setup-gear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-setup-gear.jpg"
                                      src="assets/images/demo/home-setup-gear.jpg" alt="home-setup-gear">
                              </div>
                              <span class="demo-name">Home Setup Gear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-dog-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-dog-accessories.jpg"
                                      src="assets/images/demo/home-dog-accessories.jpg" alt="home-dog-accessories">
                              </div>
                              <span class="demo-name">Home Dog Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-kitchen-wear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-kitchen.jpg"
                                      src="assets/images/demo/home-kitchen.jpg" alt="home-kitchen-wear">
                              </div>
                              <span class="demo-name">Home Kitchen Wear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-phonecase.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-phonecase.jpg"
                                      src="assets/images/demo/home-phonecase.jpg" alt="home-phonecase">
                              </div>
                              <span class="demo-name">Home Phonecase</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-paddle-boards.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home_paddle_board.jpg"
                                      src="assets/images/demo/home_paddle_board.jpg" alt="home-paddle_board">
                              </div>
                              <span class="demo-name">Home Paddle Boards</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-glasses.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-glasses.jpg"
                                      src="assets/images/demo/home-glasses.jpg" alt="home-glasses">
                              </div>
                              <span class="demo-name">Home Glasses</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-pod-store.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-pod-store.jpg"
                                      src="assets/images/demo/home-pod-store.jpg" alt="home-pod-store">
                              </div>
                              <span class="demo-name">Home POD Store</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-activewear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-activewear.jpg"
                                      src="assets/images/demo/home-activewear.jpg" alt="home-activewear">
                              </div>
                              <span class="demo-name">Activewear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-handbag.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-handbag.jpg"
                                      src="assets/images/demo/home-handbag.jpg" alt="home-handbag">
                              </div>
                              <span class="demo-name">Home Handbag</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-tee.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-tee.jpg"
                                      src="assets/images/demo/home-tee.jpg" alt="home-tee">
                              </div>
                              <span class="demo-name">Home Tee</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-sock.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-socks.jpg"
                                      src="assets/images/demo/home-socks.jpg" alt="home-sock">
                              </div>
                              <span class="demo-name">Home Sock</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-jewerly.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-jewelry.jpg"
                                      src="assets/images/demo/home-jewelry.jpg" alt="home-jewelry">
                              </div>
                              <span class="demo-name">Home Jewelry</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-sneaker.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-sneaker.jpg"
                                      src="assets/images/demo/home-sneaker.jpg" alt="home-sneaker">
                              </div>
                              <span class="demo-name">Home Sneaker</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-accessories.jpg"
                                      src="assets/images/demo/home-accessories.jpg" alt="home-accessories">
                              </div>
                              <span class="demo-name">Home Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-grocery.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-gocery.jpg"
                                      src="assets/images/demo/home-gocery.jpg" alt="home-grocery">
                              </div>
                              <span class="demo-name">Home Grocery</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-baby.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-baby.jpg"
                                      src="assets/images/demo/home-baby.jpg" alt="home-baby">
                              </div>
                              <span class="demo-name">Home Baby</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-cosmetic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-cosmetic.png"
                                      src="assets/images/demo/home-cosmetic.png" alt="home-cosmetic">
                              </div>
                              <span class="demo-name">Home Cosmetic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-plant.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-plant.png"
                                      src="assets/images/demo/home-plant.png" alt="home-plant">
                              </div>
                              <span class="demo-name">Home Plant</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-swimwear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-swimwear.png"
                                      src="assets/images/demo/home-swimwear.png" alt="home-swimwear">
                              </div>
                              <span class="demo-name">Home Swimwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-electric-bike.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-electric-bike.png"
                                      src="assets/images/demo/home-electric-bike.png" alt="home-electric-bike">
                              </div>
                              <span class="demo-name">Home Electric Bike</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-footwear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-footwear.jpg"
                                      src="assets/images/demo/home-footwear.jpg" alt="home-footwear">
                              </div>
                              <span class="demo-name">Home Footwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-book-store.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-bookstore.png"
                                      src="assets/images/demo/home-bookstore.png" alt="home-bookstore">
                              </div>
                              <span class="demo-name">Home Bookstore</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-gaming-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-gaming-accessories.png"
                                      src="assets/images/demo/home-gaming-accessories.png" alt="home-gaming-accessories">
                              </div>
                              <span class="demo-name">Home Gaming Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-parallax.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                      src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                              </div>
                              <span class="demo-name">Home Parallax</span>
                          </a>
                      </div>
                  </div>
              </div>

          </div>
      </div>
  </div>
  <!-- /modalDemo -->

  <!-- mobile menu -->
  <div class="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
      <div class="mb-canvas-content">
          <div class="mb-body">
              <ul class="nav-ul-mb" id="wrapper-menu-navigation">
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-one" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-one">
                          <span>Home</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-one" class="collapse">
                          <ul class="sub-nav-menu">
                              <li><a href="index.html" class="sub-nav-link">Home Fashion 01</a></li>
                              <li><a href="home-02.html" class="sub-nav-link">Home Fashion 02</a></li>
                              <li><a href="home-03.html" class="sub-nav-link">Home Fashion 03</a></li>
                              <li><a href="home-04.html" class="sub-nav-link">Home Fashion 04</a></li>
                              <li><a href="home-05.html" class="sub-nav-link">Home Fashion 05</a></li>
                              <li><a href="home-06.html" class="sub-nav-link">Home Fashion 06</a></li>
                              <li><a href="home-07.html" class="sub-nav-link">Home Fashion 07</a></li>
                              <li><a href="home-08.html" class="sub-nav-link">Home Fashion 08</a></li>
                              <li><a href="home-giftcard.html" class="sub-nav-link">Home Gift Card</a></li>
                              <li><a href="home-headphone.html" class="sub-nav-link">Home Headphone</a></li>
                              <li><a href="home-multi-brand.html" class="sub-nav-link">Home Multi Brand</a></li>
                              <li><a href="home-skincare.html" class="sub-nav-link">Home skincare</a></li>
                              <li><a href="home-furniture.html" class="sub-nav-link">Home Furniture</a></li>
                              <li><a href="home-furniture-02.html" class="sub-nav-link">Home Furniture 2</a></li>
                              <li><a href="home-skateboard.html" class="sub-nav-link">Home Skateboard</a></li>
                              <li><a href="home-stroller.html" class="sub-nav-link">Home Stroller</a></li>
                              <li><a href="home-decor.html" class="sub-nav-link">Home Decor</a></li>
                              <li><a href="home-electronic.html" class="sub-nav-link">Home Electronic</a></li>
                              <li><a href="home-setup-gear.html" class="sub-nav-link">Home Setup Gear</a></li>
                              <li><a href="home-dog-accessories.html" class="sub-nav-link">Home Dog Accessories</a>
                              </li>
                              <li><a href="home-kitchen-wear.html" class="sub-nav-link">Home Kitchen Wear</a></li>
                              <li><a href="home-phonecase.html" class="sub-nav-link">Home Phonecase</a></li>
                              <li><a href="home-paddle-boards.html" class="sub-nav-link">Home Paddle Boards</a></li>
                              <li><a href="home-glasses.html" class="sub-nav-link">Home Glasses</a></li>
                              <li><a href="home-pod-store.html" class="sub-nav-link">Home POD Store</a></li>
                              <li><a href="home-activewear.html" class="sub-nav-link">Home Activewear</a></li>
                              <li><a href="home-handbag.html" class="sub-nav-link">Home Handbag</a></li>
                              <li><a href="home-tee.html" class="sub-nav-link">Home Tee</a></li>
                              <li><a href="home-sock.html" class="sub-nav-link">Home Sock</a></li>
                              <li><a href="home-jewerly.html" class="sub-nav-link">Home Jewelry</a></li>
                              <li><a href="home-sneaker.html" class="sub-nav-link">Home Sneaker</a></li>
                              <li><a href="home-accessories.html" class="sub-nav-link">Home Accessories</a></li>
                              <li><a href="home-grocery.html" class="sub-nav-link">Home Grocery</a></li>
                              <li><a href="home-baby.html" class="sub-nav-link">Home Baby</a></li>
                              <li><a href="home-personalized-pod.html" class="sub-nav-link">Home Personalized Pod</a>
                              </li>
                              <li><a href="home-pickleball.html" class="sub-nav-link">Home Pickleball</a></li>
                              <li><a href="home-ceramic.html" class="sub-nav-link">Home Ceramic</a></li>
                              <li><a href="home-food.html" class="sub-nav-link">Home Food</a></li>
                              <li><a href="home-camp-and-hike.html" class="sub-nav-link">Home Camp And Hike</a></li>
                              <li><a href="home-cosmetic.html" class="sub-nav-link">Home Cosmetic</a></li>
                              <li><a href="home-plant.html" class="sub-nav-link">Home Plant</a></li>
                              <li><a href="home-swimwear.html" class="sub-nav-link">Home Swimwear</a></li>
                              <li><a href="home-electric-bike.html" class="sub-nav-link">Home Electric Bike</a></li>
                              <li><a href="home-footwear.html" class="sub-nav-link">Home Footwear</a></li>
                              <li><a href="home-book-store.html" class="sub-nav-link">Home Book Store</a></li>
                              <li><a href="home-gaming-accessories.html" class="sub-nav-link">Home Gaming
                                      Accessories</a></li>
                              <li><a href="home-drinkwear.html" class="sub-nav-link">Home Drinkwear</a></li>
                              <li><a href="home-supplement.html" class="sub-nav-link">Home Supplement</a></li>
                              <li><a href="home-parallax.html" class="sub-nav-link">Home Parallax</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-two" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-two">
                          <span>Shop</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-two" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation">
                              <li><a href="#sub-shop-one" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-one">
                                      <span>Shop layouts</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="shop-default.html" class="sub-nav-link">Default</a></li>
                                          <li><a href="shop-left-sidebar.html" class="sub-nav-link">Left sidebar</a>
                                          </li>
                                          <li><a href="shop-right-sidebar.html" class="sub-nav-link">Right sidebar</a>
                                          </li>
                                          <li><a href="shop-fullwidth.html" class="sub-nav-link">Fullwidth</a></li>
                                          <li><a href="shop-collection-sub.html" class="sub-nav-link">Sub
                                                  collection</a></li>
                                          <li><a href="shop-collection-list.html" class="sub-nav-link">Collections
                                                  list</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-shop-two" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-two">
                                      <span>Features</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="shop-link.html" class="sub-nav-link">Pagination links</a></li>
                                          <li><a href="shop-loadmore.html" class="sub-nav-link">Pagination
                                                  loadmore</a></li>
                                          <li><a href="shop-infinite-scrolling.html" class="sub-nav-link">Pagination
                                                  infinite scrolling</a></li>
                                          <li><a href="shop-filter-sidebar.html" class="sub-nav-link">Filter
                                                  sidebar</a></li>
                                          <li><a href="shop-filter-hidden.html" class="sub-nav-link">Filter hidden</a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-shop-three" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-three">
                                      <span>Product styles</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-three" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">

                                          <li><a href="product-style-01.html" class="sub-nav-link">Product style
                                                  01</a></li>
                                          <li><a href="product-style-02.html" class="sub-nav-link">Product style
                                                  02</a></li>
                                          <li><a href="product-style-03.html" class="sub-nav-link">Product style
                                                  03</a></li>
                                          <li><a href="product-style-04.html" class="sub-nav-link">Product style
                                                  04</a></li>
                                          <li><a href="product-style-05.html" class="sub-nav-link">Product style
                                                  05</a></li>
                                          <li><a href="product-style-06.html" class="sub-nav-link">Product style
                                                  06</a></li>
                                          <li><a href="product-style-07.html" class="sub-nav-link">Product style
                                                  07</a></li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-three" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-three">
                          <span>Products</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-three" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation1">
                              <li>
                                  <a href="#sub-product-one" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-one">
                                      <span>Product layouts</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-detail.html" class="sub-nav-link">Product default</a>
                                          </li>
                                          <li><a href="product-grid-1.html" class="sub-nav-link">Product grid 1</a>
                                          </li>
                                          <li><a href="product-grid-2.html" class="sub-nav-link">Product grid 2</a>
                                          </li>
                                          <li><a href="product-stacked.html" class="sub-nav-link">Product stacked</a>
                                          </li>
                                          <li><a href="product-right-thumbnails.html" class="sub-nav-link">Product
                                                  right thumbnails</a></li>
                                          <li><a href="product-bottom-thumbnails.html" class="sub-nav-link">Product
                                                  bottom thumbnails</a></li>
                                          <li><a href="product-drawer-sidebar.html" class="sub-nav-link">Product
                                                  drawer sidebar</a></li>
                                          <li><a href="product-description-accordion.html"
                                                  class="sub-nav-link">Product description accordion</a></li>
                                          <li><a href="product-description-list.html" class="sub-nav-link">Product
                                                  description list</a></li>
                                          <li><a href="product-description-vertical.html" class="sub-nav-link">Product
                                                  description vertical</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-two" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-two">
                                      <span>Product details</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-inner-zoom.html" class="sub-nav-link">Product inner
                                                  zoom</a></li>
                                          <li><a href="product-zoom-magnifier.html" class="sub-nav-link">Product zoom
                                                  magnifier</a></li>
                                          <li><a href="product-no-zoom.html" class="sub-nav-link">Product no zoom</a>
                                          </li>
                                          <li><a href="product-photoswipe-popup.html" class="sub-nav-link">Product
                                                  photoswipe popup</a></li>
                                          <li><a href="product-zoom-popup.html" class="sub-nav-link">Product external
                                                  zoom and photoswipe popup</a></li>
                                          <li><a href="product-video.html" class="sub-nav-link">Product video</a></li>
                                          <li><a href="product-3d.html" class="sub-nav-link">Product 3D, AR models</a>
                                          </li>
                                          <li><a href="product-options-customizer.html" class="sub-nav-link">Product
                                                  options & customizer</a></li>
                                          <li><a href="product-advanced-types.html" class="sub-nav-link">Advanced
                                                  product types</a></li>
                                          <li><a href="product-giftcard.html" class="sub-nav-link">Recipient
                                                  information form for gift card products</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-three" class="sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true"
                                      aria-controls="sub-product-three">
                                      <span>Product swatchs</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-three" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-color-swatch.html" class="sub-nav-link">Product color
                                                  swatch</a></li>
                                          <li><a href="product-rectangle.html" class="sub-nav-link">Product
                                                  rectangle</a></li>
                                          <li><a href="product-rectangle-color.html" class="sub-nav-link">Product
                                                  rectangle color</a></li>
                                          <li><a href="product-swatch-image.html" class="sub-nav-link">Product swatch
                                                  image</a></li>
                                          <li><a href="product-swatch-image-rounded.html" class="sub-nav-link">Product
                                                  swatch image rounded</a></li>
                                          <li><a href="product-swatch-dropdown.html" class="sub-nav-link">Product
                                                  swatch dropdown</a></li>
                                          <li><a href="product-swatch-dropdown-color.html"
                                                  class="sub-nav-link">Product swatch dropdown color</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-four" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-four">
                                      <span>Product features</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-four" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-frequently-bought-together.html"
                                                  class="sub-nav-link">Frequently bought together</a></li>
                                          <li><a href="product-frequently-bought-together-2.html"
                                                  class="sub-nav-link">Frequently bought together 2</a></li>
                                          <li><a href="product-upsell-features.html" class="sub-nav-link">Product
                                                  upsell features</a></li>
                                          <li><a href="product-pre-orders.html" class="sub-nav-link">Product
                                                  pre-orders</a></li>
                                          <li><a href="product-notification.html" class="sub-nav-link">Back in stock
                                                  notification</a></li>
                                          <li><a href="product-pickup.html" class="sub-nav-link">Product pickup</a>
                                          </li>
                                          <li><a href="product-images-grouped.html" class="sub-nav-link">Variant
                                                  images grouped</a></li>
                                          <li><a href="product-complimentary.html" class="sub-nav-link">Complimentary
                                                  products</a></li>
                                          <li><a href="product-quick-order-list.html"
                                                  class="sub-nav-link line-clamp">Quick order list<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-volume-discount.html"
                                                  class="sub-nav-link line-clamp">Volume Discount<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-volume-discount-grid.html"
                                                  class="sub-nav-link line-clamp">Volume Discount Grid<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-buyx-gety.html"
                                                  class="sub-nav-link line-clamp">Buy X Get Y<div class="demo-label">
                                                      <span class="demo-new">New</span>
                                                  </div></a></li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-four" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-four">
                          <span>Pages</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-four" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation2">
                              <li><a href="about-us.html" class="sub-nav-link">About us</a></li>
                              <li><a href="brands.html" class="sub-nav-link line-clamp">Brands<div class="demo-label">
                                          <span class="demo-new">New</span>
                                      </div></a></li>
                              <li><a href="brands-v2.html" class="sub-nav-link">Brands V2</a></li>
                              <li><a href="contact-1.html" class="sub-nav-link">Contact 1</a></li>
                              <li><a href="contact-2.html" class="sub-nav-link">Contact 2</a></li>
                              <li><a href="faq-1.html" class="sub-nav-link">FAQ 01</a></li>
                              <li><a href="faq-2.html" class="sub-nav-link">FAQ 02</a></li>
                              <li><a href="our-store.html" class="sub-nav-link">Our store</a></li>
                              <li><a href="store-locations.html" class="sub-nav-link">Store locator</a></li>
                              <li><a href="timeline.html" class="sub-nav-link line-clamp">Timeline<div
                                          class="demo-label"><span class="demo-new">New</span></div></a></li>
                              <li><a href="view-cart.html" class="sub-nav-link line-clamp">View cart</a></li>
                              <li><a href="checkout.html" class="sub-nav-link line-clamp">Check out</a></li>
                              <li><a href="payment-confirmation.html" class="sub-nav-link line-clamp">Payment
                                      Confirmation</a></li>
                              <li><a href="payment-failure.html" class="sub-nav-link line-clamp">Payment Failure</a>
                              </li>
                              <li><a href="#sub-account" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-account">
                                      <span>My Account</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-account" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="my-account.html" class="sub-nav-link">My account</a></li>
                                          <li><a href="my-account-orders.html" class="sub-nav-link">My order</a></li>
                                          <li><a href="my-account-orders-details.html" class="sub-nav-link">My order
                                                  details</a></li>
                                          <li><a href="my-account-address.html" class="sub-nav-link">My address</a>
                                          </li>
                                          <li><a href="my-account-edit.html" class="sub-nav-link">My account
                                                  details</a></li>
                                          <li><a href="my-account-wishlist.html" class="sub-nav-link">My wishlist</a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li><a href="invoice.html" class="sub-nav-link line-clamp">Invoice</a></li>
                              <li><a href="404.html" class="sub-nav-link line-clamp">404</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-five" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-five">
                          <span>Blog</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-five" class="collapse">
                          <ul class="sub-nav-menu">
                              <li><a href="blog-grid.html" class="sub-nav-link">Grid layout</a></li>
                              <li><a href="blog-sidebar-left.html" class="sub-nav-link">Left sidebar</a></li>
                              <li><a href="blog-sidebar-right.html" class="sub-nav-link">Right sidebar</a></li>
                              <li><a href="blog-list.html" class="sub-nav-link">Blog list</a></li>
                              <li><a href="blog-detail.html" class="sub-nav-link">Single Post</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="https://themeforest.net/item/ecomus-ultimate-html5-template/53417990?s_rank=3"
                          class="mb-menu-link">Buy now</a>
                  </li>
              </ul>
              <div class="mb-other-content">
                  <div class="d-flex group-icon">
                      <a href="wishlist.html" class="site-nav-icon"><i class="icon icon-heart"></i>Wishlist</a>
                      <a href="home-search.html" class="site-nav-icon"><i class="icon icon-search"></i>Search</a>
                  </div>
                  <div class="mb-notice">
                      <a href="contact-1.html" class="text-need">Need help ?</a>
                  </div>
                  <ul class="mb-info">
                      <li>Address: 1234 Fashion Street, Suite 567, <br> New York, NY 10001</li>
                      <li>Email: <b>info@fashionshop.com</b></li>
                      <li>Phone: <b>(212) 555-1234</b></li>
                  </ul>
              </div>
          </div>
          <div class="mb-bottom">
              <a href="login.html" class="site-nav-icon"><i class="icon icon-account"></i>Login</a>
              <div class="bottom-bar-language">
                  <div class="tf-currencies">
                      <select class="image-select center style-default type-currencies">
                          <option data-thumbnail="assets/images/country/fr.svg">EUR € | France</option>
                          <option data-thumbnail="assets/images/country/de.svg">EUR € | Germany</option>
                          <option selected data-thumbnail="assets/images/country/us.svg">USD $ | United States</option>
                          <option data-thumbnail="assets/images/country/vn.svg">VND ₫ | Vietnam</option>
                      </select>
                  </div>
                  <div class="tf-languages">
                      <select class="image-select center style-default type-languages">
                          <option>English</option>
                          <option>العربية</option>
                          <option>简体中文</option>
                          <option>اردو</option>
                      </select>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /mobile menu -->



  <!-- canvasSearch -->
  <div class="offcanvas offcanvas-end canvas-search" id="canvasSearch">
      <div class="canvas-wrapper">
          <header class="tf-search-head">
              <div class="title fw-5">
                  Search our site
                  <div class="close">
                      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
                  </div>
              </div>
              <div class="tf-search-sticky">
                  <form class="tf-mini-search-frm">
                      <fieldset class="text">
                          <input type="text" placeholder="Search" class="" name="text" tabindex="0" value=""
                              aria-required="true" required="">
                      </fieldset>
                      <button class="" type="submit"><i class="icon-search"></i></button>
                  </form>
              </div>
          </header>
          <div class="canvas-body p-0">
              <div class="tf-search-content">
                  <div class="tf-cart-hide-has-results">
                      <div class="tf-col-quicklink">
                          <div class="tf-search-content-title fw-5">Quick link</div>
                          <ul class="tf-quicklink-list">
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Fashion</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Men</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Women</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Accessories</a>
                              </li>
                          </ul>
                      </div>
                      <div class="tf-col-content">
                          <div class="tf-search-content-title fw-5">Need some inspiration?</div>
                          <div class="tf-search-hidden-inner">
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-3.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Cotton jersey top</a>
                                      <div class="tf-product-info-price">
                                          <div class="compare-at-price">$10.00</div>
                                          <div class="price-on-sale fw-6">$8.00</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-2.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Mini crossbody bag</a>
                                      <div class="tf-product-info-price">
                                          <div class="price fw-6">$18.00</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-1.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Oversized Printed T-shirt</a>
                                      <div class="tf-product-info-price">
                                          <div class="price fw-6">$18.00</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /canvasSearch -->

  <!-- toolbarShopmb -->
  <div class="offcanvas offcanvas-start canvas-mb toolbar-shop-mobile" id="toolbarShopmb">
      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
      <div class="mb-canvas-content">
          <div class="mb-body">
              <ul class="nav-ul-mb" id="wrapper-menu-navigation">
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate1.jpg" alt="">
                          </div>
                          <span>Accessories</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate2.jpg" alt="">
                          </div>
                          <span>Dog</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate3.jpg" alt="">
                          </div>
                          <span>Grocery</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate4.png" alt="">
                          </div>
                          <span>Handbag</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-one" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-one">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate5.jpg" alt="">
                          </div>
                          <span>Fashion</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-one" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation">
                              <li>
                                  <a href="#cate-shop-one"
                                      class="tf-category-link has-children sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-shop-one">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate6.jpg" alt="">
                                      </div>
                                      <span>Mens</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="cate-shop-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate1.jpg" alt="">
                                                  </div>
                                                  <span>Accessories</span>
                                              </a>
                                          </li>
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate8.jpg" alt="">
                                                  </div>
                                                  <span>Shoes</span>
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#cate-shop-two"
                                      class="tf-category-link has-children sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-shop-two">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate9.jpg" alt="">
                                      </div>
                                      <span>Womens</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="cate-shop-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate4.png" alt="">
                                                  </div>
                                                  <span>Handbag</span>
                                              </a>
                                          </li>
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate7.jpg" alt="">
                                                  </div>
                                                  <span>Tee</span>
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-two" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-two">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate6.jpg" alt="">
                          </div>
                          <span>Men</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-two" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation1">
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate1.jpg" alt="">
                                      </div>
                                      <span>Accessories</span>
                                  </a>
                              </li>
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate8.jpg" alt="">
                                      </div>
                                      <span>Shoes</span>
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate7.jpg" alt="">
                          </div>
                          <span>Tee</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate8.jpg" alt="">
                          </div>
                          <span>Shoes</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-three" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-three">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate9.jpg" alt="">
                          </div>
                          <span>Women</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-three" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation2">
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate4.png" alt="">
                                      </div>
                                      <span>Handbag</span>
                                  </a>
                              </li>
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate7.jpg" alt="">
                                      </div>
                                      <span>Tee</span>
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </li>
              </ul>
          </div>
          <div class="mb-bottom">
              <a href="shop-default.html" class="tf-btn fw-5 btn-line">View all collection<i
                      class="icon icon-arrow1-top-left"></i></a>
          </div>
      </div>
  </div>
  <!-- /toolbarShopmb -->

  <!-- modal login -->
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="login">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Log in</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="" action="my-account.html" accept-charset="utf-8">
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="password" name="">
                          <label class="tf-field-label" for="">Password *</label>
                      </div>
                      <div>
                          <a href="#forgotPassword" data-bs-toggle="modal" class="btn-link link">Forgot your
                              password?</a>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <button type="submit"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Log
                                      in</span></button>
                          </div>
                          <div class="w-100">
                              <a href="#register" data-bs-toggle="modal" class="btn-link fw-6 w-100 link">
                                  New customer? Create your account
                                  <i class="icon icon-arrow1-top-left"></i>
                              </a>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="forgotPassword">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Reset your password</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="">
                      <div>
                          <p>Sign up for early Sale access plus tailored new arrivals, trends and promotions. To opt
                              out, click unsubscribe in our emails</p>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div>
                          <a href="#login" data-bs-toggle="modal" class="btn-link link">Cancel</a>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <button type="submit"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Reset
                                      password</span></button>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="register">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Register</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="">
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">First name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">Last name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="password" name="">
                          <label class="tf-field-label" for="">Password *</label>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <a href="register.html"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Register</span></a>
                          </div>
                          <div class="w-100">
                              <a href="#login" data-bs-toggle="modal" class="btn-link fw-6 w-100 link">
                                  Already have an account? Log in here
                                  <i class="icon icon-arrow1-top-left"></i>
                              </a>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal login -->
  <!-- modal compare -->
  <div class="offcanvas offcanvas-bottom canvas-compare" id="compare">
      <div class="canvas-wrapper">
          <header class="canvas-header">
              <div class="close-popup">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
              </div>
          </header>
          <div class="canvas-body">
              <div class="container">
                  <div class="row">
                      <div class="col-12">
                          <div class="tf-compare-list">
                              <div class="tf-compare-head">
                                  <div class="title">Compare Products</div>
                              </div>
                              <div class="tf-compare-offcanvas">
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/orange-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/pink-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-compare-buttons">
                                  <div class="tf-compare-buttons-wrap">
                                      <a href="compare.html"
                                          class="tf-btn radius-3 btn-fill justify-content-center fw-6 fs-14 flex-grow-1 animate-hover-btn ">Compare</a>
                                      <div class="tf-compapre-button-clear-all link">
                                          Clear All
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal compare -->

  <!-- modal quick_add -->
  <div class="modal fade modalDemo" id="quick_add">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-info-item">
                      <div class="image">
                          <img src="assets/assets/images/products/orange-1.jpg" alt="">
                      </div>
                      <div class="content">
                          <a href="product-detail.html">Ribbed Tank Top</a>
                          <div class="tf-product-info-price">
                              <!-- <div class="price-on-sale">$8.00</div>
                              <div class="compare-at-price">$10.00</div>
                              <div class="badges-on-sale"><span>20</span>% OFF</div> -->
                              <div class="price">$18.00</div>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-variant-picker mb_15">
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                          </div>
                          <div class="variant-picker-values">
                              <input id="values-orange" type="radio" name="color" checked>
                              <label class="hover-tooltip radius-60" for="values-orange" data-value="Orange">
                                  <span class="btn-checkbox bg-color-orange"></span>
                                  <span class="tooltip">Orange</span>
                              </label>
                              <input id="values-black" type="radio" name="color">
                              <label class=" hover-tooltip radius-60" for="values-black" data-value="Black">
                                  <span class="btn-checkbox bg-color-black"></span>
                                  <span class="tooltip">Black</span>
                              </label>
                              <input id="values-white" type="radio" name="color">
                              <label class="hover-tooltip radius-60" for="values-white" data-value="White">
                                  <span class="btn-checkbox bg-color-white"></span>
                                  <span class="tooltip">White</span>
                              </label>
                          </div>
                      </div>
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Size: <span class="fw-6 variant-picker-label-value">S</span>
                          </div>
                          <div class="variant-picker-values">
                              <input type="radio" name="size" id="values-s" checked>
                              <label class="style-text" for="values-s" data-value="S">
                                  <p>S</p>
                              </label>
                              <input type="radio" name="size" id="values-m">
                              <label class="style-text" for="values-m" data-value="M">
                                  <p>M</p>
                              </label>
                              <input type="radio" name="size" id="values-l">
                              <label class="style-text" for="values-l" data-value="L">
                                  <p>L</p>
                              </label>
                              <input type="radio" name="size" id="values-xl">
                              <label class="style-text" for="values-xl" data-value="XL">
                                  <p>XL</p>
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-quantity mb_15">
                      <div class="quantity-title fw-6">Quantity</div>
                      <div class="wg-quantity">
                          <span class="btn-quantity minus-btn">-</span>
                          <input type="text" name="number" value="1">
                          <span class="btn-quantity plus-btn">+</span>
                      </div>
                  </div>
                  <div class="tf-product-info-buy-button">
                      <form class="">
                          <a href="javascript:void(0);"
                              class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                  to cart -&nbsp;</span><span class="tf-qty-price">$18.00</span></a>
                          <div class="tf-product-btn-wishlist btn-icon-action">
                              <i class="icon-heart"></i>
                              <i class="icon-delete"></i>
                          </div>
                          <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                              class="tf-product-btn-wishlist box-icon bg_white compare btn-icon-action">
                              <span class="icon icon-compare"></span>
                              <span class="icon icon-check"></span>
                          </a>
                          <div class="w-100">
                              <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png" alt=""></a>
                              <a href="#" class="payment-more-option">More payment options</a>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_add -->

  <!-- modal quick_view -->
  <div class="modal fade modalDemo" id="quick_view">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-media-wrap">
                      <div dir="ltr" class="swiper tf-single-slide">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/orange-1.jpg" alt="">
                                  </div>
                              </div>
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/pink-1.jpg" alt="">
                                  </div>
                              </div>
                          </div>
                          <div class="swiper-button-next button-style-arrow single-slide-prev"></div>
                          <div class="swiper-button-prev button-style-arrow single-slide-next"></div>
                      </div>
                  </div>
                  <div class="tf-product-info-wrap position-relative">
                      <div class="tf-product-info-list">
                          <div class="tf-product-info-title">
                              <h5><a class="link" href="product-detail.html">Ribbed Tank Top</a></h5>
                          </div>
                          <div class="tf-product-info-badges">
                              <div class="badges text-uppercase">Best seller</div>
                              <div class="product-status-content">
                                  <i class="icon-lightning"></i>
                                  <p class="fw-6">Selling fast! 48 people have this in their carts.</p>
                              </div>
                          </div>
                          <div class="tf-product-info-price">
                              <div class="price">$18.00</div>
                          </div>
                          <div class="tf-product-description">
                              <p>Nunc arcu faucibus a et lorem eu a mauris adipiscing conubia ac aptent ligula
                                  facilisis a auctor habitant parturient a a.Interdum fermentum.</p>
                          </div>
                          <div class="tf-product-info-variant-picker">
                              <div class="variant-picker-item">
                                  <div class="variant-picker-label">
                                      Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input id="values-orange-1" type="radio" name="color-1" checked>
                                      <label class="hover-tooltip radius-60" for="values-orange-1"
                                          data-value="Orange">
                                          <span class="btn-checkbox bg-color-orange"></span>
                                          <span class="tooltip">Orange</span>
                                      </label>
                                      <input id="values-black-1" type="radio" name="color-1">
                                      <label class=" hover-tooltip radius-60" for="values-black-1" data-value="Black">
                                          <span class="btn-checkbox bg-color-black"></span>
                                          <span class="tooltip">Black</span>
                                      </label>
                                      <input id="values-white-1" type="radio" name="color-1">
                                      <label class="hover-tooltip radius-60" for="values-white-1" data-value="White">
                                          <span class="btn-checkbox bg-color-white"></span>
                                          <span class="tooltip">White</span>
                                      </label>
                                  </div>
                              </div>
                              <div class="variant-picker-item">
                                  <div class="d-flex justify-content-between align-items-center">
                                      <div class="variant-picker-label">
                                          Size: <span class="fw-6 variant-picker-label-value">S</span>
                                      </div>
                                      <div class="find-size btn-choose-size fw-6">Find your size</div>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input type="radio" name="size-1" id="values-s-1" checked>
                                      <label class="style-text" for="values-s-1" data-value="S">
                                          <p>S</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-m-1">
                                      <label class="style-text" for="values-m-1" data-value="M">
                                          <p>M</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-l-1">
                                      <label class="style-text" for="values-l-1" data-value="L">
                                          <p>L</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-xl-1">
                                      <label class="style-text" for="values-xl-1" data-value="XL">
                                          <p>XL</p>
                                      </label>
                                  </div>
                              </div>
                          </div>
                          <div class="tf-product-info-quantity">
                              <div class="quantity-title fw-6">Quantity</div>
                              <div class="wg-quantity">
                                  <span class="btn-quantity minus-btn">-</span>
                                  <input type="text" name="number" value="1">
                                  <span class="btn-quantity plus-btn">+</span>
                              </div>
                          </div>
                          <div class="tf-product-info-buy-button">
                              <form class="">
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                          to cart -&nbsp;</span><span class="tf-qty-price">$8.00</span></a>
                                  <a href="javascript:void(0);"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white wishlist btn-icon-action">
                                      <span class="icon icon-heart"></span>
                                      <span class="tooltip">Add to Wishlist</span>
                                      <span class="icon icon-delete"></span>
                                  </a>
                                  <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white compare btn-icon-action">
                                      <span class="icon icon-compare"></span>
                                      <span class="tooltip">Add to Compare</span>
                                      <span class="icon icon-check"></span>
                                  </a>
                                  <div class="w-100">
                                      <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png"
                                              alt=""></a>
                                      <a href="#" class="payment-more-option">More payment options</a>
                                  </div>
                              </form>
                          </div>
                          <div>
                              <a href="product-detail.html" class="tf-btn fw-6 btn-line">View full details<i
                                      class="icon icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_view -->

  <!-- modal find_size -->
  <div class="modal fade modalDemo tf-product-modal" id="find_size">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Size chart</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-rte">
                  <div class="tf-table-res-df">
                      <h6>Size guide</h6>
                      <table class="tf-sizeguide-table">
                          <thead>
                              <tr>
                                  <th>Size</th>
                                  <th>US</th>
                                  <th>Bust</th>
                                  <th>Waist</th>
                                  <th>Low Hip</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>XS</td>
                                  <td>2</td>
                                  <td>32</td>
                                  <td>24 - 25</td>
                                  <td>33 - 34</td>
                              </tr>
                              <tr>
                                  <td>S</td>
                                  <td>4</td>
                                  <td>34 - 35</td>
                                  <td>26 - 27</td>
                                  <td>35 - 26</td>
                              </tr>
                              <tr>
                                  <td>M</td>
                                  <td>6</td>
                                  <td>36 - 37</td>
                                  <td>28 - 29</td>
                                  <td>38 - 40</td>
                              </tr>
                              <tr>
                                  <td>L</td>
                                  <td>8</td>
                                  <td>38 - 29</td>
                                  <td>30 - 31</td>
                                  <td>42 - 44</td>
                              </tr>
                              <tr>
                                  <td>XL</td>
                                  <td>10</td>
                                  <td>40 - 41</td>
                                  <td>32 - 33</td>
                                  <td>45 - 47</td>
                              </tr>
                              <tr>
                                  <td>XXL</td>
                                  <td>12</td>
                                  <td>42 - 43</td>
                                  <td>34 - 35</td>
                                  <td>48 - 50</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div class="tf-page-size-chart-content">
                      <div>
                          <h6>Measuring Tips</h6>
                          <div class="title">Bust</div>
                          <p>Measure around the fullest part of your bust.</p>
                          <div class="title">Waist</div>
                          <p>Measure around the narrowest part of your torso.</p>
                          <div class="title">Low Hip</div>
                          <p class="mb-0">With your feet together measure around the fullest part of your hips/rear.
                          </p>
                      </div>
                      <div>
                          <img class="sizechart lazyload" data-src="assets/images/shop/products/size_chart2.jpg"
                              src="assets/images/shop/products/size_chart2.jpg" alt="">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal find_size -->

